module.exports = __webpack_public_path__ + "img/vct.4ac5124f.svg";